var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { initialOptions, defaultApiParams, defaultParams } from './const';
var Report = /** @class */ (function () {
    function Report(beaconInstance, options) {
        this.options = initialOptions;
        this.beaconInstance = beaconInstance;
        this.options = __assign(__assign({}, this.options), options);
        if (!this.beaconInstance) {
            this.options.stopReport = true;
        }
        this.internalLog("Options " + JSON.stringify(this.options));
    }
    Report.prototype.pv = function (params) {
        this.baseReport('event_pv', params);
    };
    Report.prototype.click = function (params, beaconOptions) {
        var nextParams = __assign(__assign({}, defaultParams), params);
        this.baseReport('event_click', nextParams, beaconOptions);
    };
    Report.prototype.exposure = function (params, beaconOptions) {
        var nextParams = __assign(__assign({}, defaultParams), params);
        this.baseReport('event_exposure', nextParams, beaconOptions);
    };
    Report.prototype.heart = function (params, beaconOptions) {
        this.baseReport('event_heart_beat', params, __assign({ direct: true }, beaconOptions));
    };
    Report.prototype.api = function (params, beaconOptions) {
        var nextParams = __assign(__assign({}, defaultApiParams), params);
        this.baseReport('consult_interface', nextParams, beaconOptions);
    };
    Report.prototype.getOptions = function () {
        return this.getOptions;
    };
    Report.prototype.baseReport = function (type, params, beaconOptions) {
        if (this.isStopReport())
            return;
        var payload = __assign({ timestamp: new Date().getTime() }, params);
        if (this.options.debug) {
            this.internalLog("ReportType: " + type + ", ReportParams: " + payload);
        }
        if (beaconOptions === null || beaconOptions === void 0 ? void 0 : beaconOptions.direct) {
            return this.beaconInstance.onDirectUserAction(type, payload);
        }
        this.beaconInstance.onUserAction(type, payload);
    };
    Report.prototype.paramsReport = function (params) {
        this.beaconInstance.addAdditionalParams(params);
    };
    Report.prototype.internalLog = function (logString) {
        var _a = this.options, debug = _a.debug, debugChannel = _a.debugChannel;
        if (debug) {
            debugChannel === null || debugChannel === void 0 ? void 0 : debugChannel.info('[report debug]:', logString);
        }
    };
    Report.prototype.isStopReport = function () {
        return this.options.stopReport;
    };
    return Report;
}());
export { Report };
